import { apiClient } from "lib/apiClient";

export const postMarketAreaSelectedField = async (
  id: string
): Promise<void> => {
  await apiClient.post(
    `/admin/market-areas/settings/selected/${encodeURIComponent(id)}`
  );
};
